import { ApplicationProgressStage } from '../types/applicationProgressStage';

export const getLinealProgressStepsArray = (progressStages: ApplicationProgressStage) =>
  Object.values(progressStages)
    .filter((stage) => !!stage)
    .flatMap((stage) => stage.flatMap((step) => step));
